<template>
  <div class="demo__margin-top--16">
    <div class="uploadButton">
      <label class="upload-btn" @click="triggerFileInput">
        {{ $t("VerifyModal.step2.selectFile") }}
        <i class="fa-solid fa-chevron-right demo__margin-left--8"></i>
      </label>
      <input
        type="file"
        ref="inputFile"
        accept="application/pdf, image/*"
        style="display: none !important"
        @change="addFile"
      />
    </div>
    <div class="demo__flex demo__flex-column demo__gap--4 demo__margin-top--16">
      <div
        v-for="(file, index) in localFiles"
        :key="index"
        class="demo__flex demo__flex-row demo__flex-between"
      >
        <div class="demo__flex demo__flex-row demo__gap--8 demo__align-center">
          <i class="fa-solid fa-paperclip fa-lg"></i>
          <span class="demo__font--14 demo__color--black demo__weight--400">
            {{ file.name }}
          </span>
        </div>
        <i class="fa-regular fa-trash fa-lg" @click="removeFile(index)"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: false,
    },
    maxCount: {
      type: Number,
      required: false,
      default: 10,
    },
  },
  data() {
    return {
      localFiles: this.value || [],
    };
  },
  watch: {
    files(newFiles) {
      this.localFiles = newFiles;
    },
  },
  methods: {
    triggerFileInput() {
      this.$refs.inputFile.click();
    },
    addFile(e) {
      const file = e.target.files[0];
      if (!file) return;

      if (
        !(file.type === "application/pdf" || file.type.startsWith("image/"))
      ) {
        this.$notify({
          group: "loggedIn",
          type: "error",
          text: this.$t("VerifyModal.step2.notAllowedFile"),
        });
        alert("Only PDF and image files are allowed.");
        return;
      }
      if (this.localFiles.length >= this.maxCount) {
        this.$notify({
          group: "loggedIn",
          type: "error",
          text: this.$t("VerifyModal.step2.noMoreFiles") + this.maxCount,
        });
        return;
      }
      this.localFiles.push(file);
      this.$emit("input", this.localFiles);
    },
    removeFile(index) {
      const updatedFiles = [...this.localFiles];
      updatedFiles.splice(index, 1);
      this.$emit("input", updatedFiles);
      this.localFiles = updatedFiles;
    },
  },
};
</script>
